export const Label = ({label}: any): JSX.Element => {

    return label && (
        <div dangerouslySetInnerHTML={{__html: label}}/>
    );
};
